/**
 * Routes where the general bottom navigation menu is shown.
 * Add path patterns here to enable the menu on additional pages.
 */
export const GENERAL_NAV_MENU_ROUTE_PATHS = ["/dashboard", "/dashboard/"];

function normalizeRoutePath(pathname = "") {
  return pathname.replace(/\/$/, "") || "/";
}

export function isGeneralNavMenuRoute(pathname = "") {
  const normalized = normalizeRoutePath(pathname);
  return GENERAL_NAV_MENU_ROUTE_PATHS.some(
    (routePath) => normalizeRoutePath(routePath) === normalized
  );
}
